<template>
  <div v-if="isAuthModalLoading" class="auth-loading-modal">
    <LoadingIcon :isLoading="isAuthModalLoading" />
  </div>
</template>

<script>
  import { mapState } from 'vuex'
  import LoadingIcon from '@/components/layout/LoadingIcon'

  export default {
    components: {
      LoadingIcon,
    },
    computed: {
      ...mapState('auth', ['isAuthModalLoading'])
    }
  }
</script>

<style scoped lang="scss">
  .auth-loading-modal {
    position: absolute;
    display: flex;
    align-items: center;
    justify-content: center;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: rgba(#fff, .8);
    z-index: 10;
  }
</style>